export default __webpack_public_path__ + "static/media/bg-beta.31d5fc31.jpg";